import React from "react";
import ErrorPage from "./ErrorPage";

export default function Error404(props) {
  return <ErrorPage code={404} {...props} />;
}
